var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuggage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    className: "hovered-paths",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4a4a60",
    d: "M198.005 422.55v31.62H82.855c-13.38 0-24.33-10.95-24.33-24.33V180.43c0-13.38 10.95-24.33 24.33-24.33h30.66v46.23h-19.31v68.89h19.31v126.33c0 13.75 11.25 25 25 25z",
    "data-original": "#4a4a60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f58659",
    d: "M242.435 26.75h-128.15c-.26 0-.52.01-.77.03V156.1h9.27V83.7h111.15v72.4h17V35.25c0-4.69-3.81-8.5-8.5-8.5m-8.5 39.95h-111.15V43.75h111.15z",
    "data-original": "#f58659"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#dc593a",
    d: "M113.515 26.78V156.1h-7.73V35.25c0-4.43 3.39-8.08 7.73-8.47",
    "data-original": "#dc593a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5a4a4",
    d: "M94.205 202.33h19.31v68.89h-19.31z",
    className: "hovered-path",
    "data-original": "#a5a4a4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e87a31",
    d: "M245.035 420.7v64.55h-22.7c-13.38 0-24.33-10.95-24.33-24.33V336.16c0-13.38 10.95-24.33 24.33-24.33h7.1v85.72c0 10.43 6.47 19.42 15.6 23.15",
    "data-original": "#e87a31"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#526e3b",
    d: "M406.445 422.55v62.7h-161.41V420.7a24.7 24.7 0 0 0 9.4 1.85z",
    "data-original": "#526e3b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#dc593a",
    d: "M453.475 422.55v38.37c0 13.38-10.94 24.33-24.33 24.33h-22.7v-62.7z",
    "data-original": "#dc593a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f58659",
    d: "M453.475 336.16v86.39h-47.03V311.83h22.7c13.39 0 24.33 10.95 24.33 24.33",
    "data-original": "#f58659"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#e87a31",
    d: "M94.205 454.17h30.01v31.08h-30.01z",
    "data-original": "#e87a31"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b6a70",
    d: "M273.865 156.1h-160.35v46.23h57.54v68.89h-57.54v126.33c0 13.75 11.25 25 25 25h59.49v-86.39c0-13.38 10.95-24.33 24.33-24.33h39.75v-29.2c0-18.1 14.73-32.83 32.83-32.83h3.28v-69.37c0-13.38-10.95-24.33-24.33-24.33m-7.3 89.18h-60.83a8.5 8.5 0 0 1-8.5-8.5c0-4.7 3.8-8.5 8.5-8.5h60.83a8.5 8.5 0 1 1 0 17m0-34.45h-60.83c-4.7 0-8.5-3.8-8.5-8.5a8.5 8.5 0 0 1 8.5-8.5h60.83a8.5 8.5 0 1 1 0 17",
    "data-original": "#5b6a70"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5a4a4",
    d: "M275.065 202.33a8.5 8.5 0 0 1-8.5 8.5h-60.83c-4.7 0-8.5-3.8-8.5-8.5a8.5 8.5 0 0 1 8.5-8.5h60.83c4.69 0 8.5 3.81 8.5 8.5m0 34.45c0 4.69-3.81 8.5-8.5 8.5h-60.83a8.5 8.5 0 0 1-8.5-8.5c0-4.7 3.8-8.5 8.5-8.5h60.83a8.5 8.5 0 0 1 8.5 8.5",
    className: "hovered-path",
    "data-original": "#a5a4a4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#dc593a",
    d: "M389.395 282.63v29.2h-17v-29.2c0-8.73-7.1-15.83-15.83-15.83h-61.65c-8.73 0-15.83 7.1-15.83 15.83v29.2h-17v-29.2c0-18.1 14.73-32.83 32.83-32.83h61.65c18.1 0 32.83 14.73 32.83 32.83",
    "data-original": "#dc593a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b6a70",
    d: "M298.195 266.8v45.03h-19.11v-29.2c0-8.73 7.1-15.83 15.83-15.83z",
    "data-original": "#5b6a70"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#86a473",
    d: "M406.445 311.83v110.72h-152.01c-3.32 0-6.5-.66-9.4-1.85V311.83z",
    "data-original": "#86a473"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb556",
    d: "M245.035 311.83V420.7c-9.13-3.729-15.6-12.72-15.6-23.15v-85.72z",
    "data-original": "#fcb556"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#cccccd",
    d: "M113.515 202.33h57.54v68.89h-57.54z",
    "data-original": "#cccccd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggage);
export default __webpack_public_path__ + "static/media/luggage.e20fe3652de0c369adc2dc7520fc07d8.svg";
export { ForwardRef as ReactComponent };